export const capitalize = (str: string) =>
  str && str.split("")[0].toUpperCase() + str.slice(1);